import React, { createContext, useContext, useState, useEffect } from 'react'

import CookieBanner from '@/components/CookieBanner.jsx'
const CookieContext = createContext()

export function useCookieConsent() {
  return useContext(CookieContext)
}

const defaultPrefs = { essential: true, functional: false, analytics: false, marketing: false }

export function CookieConsentProvider({ children }) {
  const [prefs, setPrefs] = useState(defaultPrefs)
  const [ready, setReady] = useState(false)          // ensure scripts load after reading storage
  const [showBanner, setShowBanner] = useState(false)

  /* ── on mount: read localStorage ───────────────── */
  useEffect(() => {
    
    const stored = localStorage.getItem('cookieConsent')
    if (stored) {
      setPrefs(JSON.parse(stored))
    } else {
      setShowBanner(true)           // first-time visit
    }
    setReady(true)
  }, [])

  /* ── helper : update prefs → storage ───────────── */
  const savePrefs = newPrefs => {
    setPrefs(newPrefs)
    localStorage.setItem('cookieConsent', JSON.stringify(newPrefs))
  }

  /* ── accept all non-essential ──────────────────── */
  const acceptAll = () => {
    const newPrefs = { essential: true, analytics: true, marketing: true }
    savePrefs(newPrefs)
    setShowBanner(false)
    window.location.reload()        // load scripts according prefs
  }

  /* ── reject non-essential ──────────────────────── */
  const rejectAll = () => {
    const newPrefs = { ...defaultPrefs }
    savePrefs(newPrefs)
    setShowBanner(false)
  }

  /* ── open preferences modal from footer ────────── */
  const openPrefs = () => setShowBanner(true)

  return (
    <CookieContext.Provider value={{ prefs, savePrefs, ready, openPrefs }}>
      {children}
      {showBanner && <CookieBanner onAccept={acceptAll} onReject={rejectAll} />}
    </CookieContext.Provider>
  )
}
